import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,

	AreaDiv: CommonStyles.AreaDiv,
	AreaHeader: CommonStyles.AreaHeader,

	QuestionDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding: 16px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 8px;
	`,

	QuestionTitle: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;

		& > h2 {
			${({theme}) => theme.font.small_bold};
			min-width: 30px;
		}
	`,
	QuestionInput: styled.input`
		flex-grow: 1;
		${({theme}) => theme.font.small};

		${({$small}) =>
			$small &&
			css`
				${({theme}) => theme.font.extra_small};
				text-align: center;
				width: 50px;
				border: 1px solid ${({theme}) => theme.color.grey3};
				border-radius: 4px;
				flex-grow: 0;
				margin-top: 4px;
			`}
	`,

	ControlDiv: styled.div`
		width: fit-content;
		display: flex;
		justify-content: center;
		gap: 4px;

		& > button {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 24px;
			height: 24px;
			border-radius: 4px;
			background-color: ${({theme}) => theme.color.grey2};
		}
	`,
	ChoiceDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 4px;
	`,
	Choice: styled.div`
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 8px 12px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 4px;

		& > button {
			display: flex;
			align-items: center;
		}

		& > input {
			width: 100%;
			${({theme}) => theme.font.extra_small};
		}
	`,
}

export default Style
